
        var result = require("!!../../../../node_modules/css-loader/index.js!./error-detail.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/components/error-detail/error-detail.component.css
// module id = 615
// module chunks = 0